import { Image } from "antd";
import { useTranslation } from "react-i18next";
import localStorageKey from "../../../../../enumerations/localStorageKey";
import styles from "./style.module.scss";
const StepsArea = () => {
  const { t } = useTranslation();
  const localLang = window.localStorage.getItem(localStorageKey.DEFAULT_LANG);

  return (
    <div className={styles.stepsArea} id="homeStepArea">
      <div className={styles.circleMask}>
        <div className={styles.innerCircle1}></div>
        <div className={styles.innerCircle2}></div>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.mainText}>{t("home.simple.3steps")}</div>
        <div className={styles.subText}>{t("home.quick.setting")}</div>
        <div className={styles.stepsOuterContainer}>
          <div className={styles.stepsContainer}>
            <div className={styles.step1}>
              <div className={styles.stepBubble}>
                <div className={styles.bubble1}>
                  <div className={styles.stepNum}>1</div>
                </div>
                <div className={styles.bubbleText1}>
                  <div className={styles.stepTitle}>
                    {t("home.steps.title.1")}
                  </div>
                  <div
                    className={styles.stepDesc}
                    dangerouslySetInnerHTML={{
                      __html: t("home.steps.desc.1"),
                    }}
                  />
                </div>
              </div>
              <Image
                src={"/media/basic_step01.png"}
                alt="step1"
                className={styles.stepImg}
                preview={false}
              />
              {/* <video
                className={`${styles.video}`}
                style={{ zIndex: 3 }}
                src="/media/step01.mp4"
                preload="metadata"
                loop
                playsInline={true}
                autoPlay={true}
                muted
                ref={video1Ref}
              /> */}
            </div>
            <div className={styles.step2}>
              <div className={styles.stepBubble}>
                <div className={styles.bubble2}>
                  <div className={styles.stepNum}>2</div>
                </div>
                <div className={styles.bubbleText2}>
                  <div className={styles.stepTitle}>
                    {t("home.steps.title.2")}
                  </div>
                  <div
                    className={styles.stepDesc}
                    dangerouslySetInnerHTML={{
                      __html: t("home.steps.desc.2"),
                    }}
                  />
                </div>
              </div>
              <Image
                src={`/media/${localLang}/basic_step02.png`}
                fallback={"/media/basic_step02.png"}
                alt="step2"
                className={styles.stepImg}
                preview={false}
              />
              {/* <video
                className={`${styles.video}`}
                src="/media/step02.mp4"
                preload="metadata"
                playsInline={true}
                autoPlay={true}
                muted
                loop
                ref={video2Ref}
              /> */}
            </div>
            <div className={styles.step3}>
              <div className={styles.stepBubble}>
                <div className={styles.bubble3}>
                  <div className={styles.stepNum}>3</div>
                </div>
                <div className={styles.bubbleText3}>
                  <div className={styles.stepTitle}>
                    {t("home.steps.title.3")}
                  </div>
                  <div
                    className={styles.stepDesc}
                    dangerouslySetInnerHTML={{
                      __html: t("home.steps.desc.3"),
                    }}
                  />
                </div>
              </div>
              <Image
                src={`/media/${localLang}/basic_step03.png`}
                fallback={"/media/basic_step03.png"}
                alt="step3"
                className={styles.stepImg}
                preview={false}
              />
              {/* <video
                className={`${styles.video}`}
                src="/media/step03.mp4"
                preload="metadata"
                playsInline={true}
                autoPlay={true}
                muted
                loop
                ref={video3Ref}
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepsArea;
